import React, { useContext } from "react"
import PropTypes from "prop-types"
import { AppContext } from "./context/AppContext"
import { getSubmissionStatusAsString, formatOfferValue } from "../utils/Helpers"
import { submissionStatusStyles as styles } from "./styled"
import { RebateDetailModal } from "./RebateDetailModal"

const STATUS_CONFIG = {
  Approved: { label: "Approved",           dot: "#28a745", bg: "rgba(40,167,69,0.12)",   text: "#1a7a34" },
  Sent:     { label: "Approved",           dot: "#28a745", bg: "rgba(40,167,69,0.12)",   text: "#1a7a34" },
  Received: { label: "Received",           dot: "#fd7e14", bg: "rgba(253,126,20,0.12)",  text: "#b85a00" },
  Pending:  { label: "Reviewing",          dot: "#e6a817", bg: "rgba(230,168,23,0.12)",  text: "#8a6200" },
  Partial:  { label: "Reviewing",          dot: "#e6a817", bg: "rgba(230,168,23,0.12)",  text: "#8a6200" },
  Denied:   { label: "Account ineligible", dot: "#dc3545", bg: "rgba(220,53,69,0.12)",   text: "#a71d2a" },
}

const getStatusConfig = (submission) => {
  const status = getSubmissionStatusAsString(submission)
  return STATUS_CONFIG[status] || STATUS_CONFIG.Pending
}

export const RebateList = ({
  rebates,
  title = "Your rebates",
  emptyMessage = "No rebates found for this line.",
}) => {
  const { state, dispatch } = useContext(AppContext)

  const handleRebateClick = (submission) => {
    dispatch({ type: "SETSELECTEDSUBMISSION", payload: submission })
  }

  const handleModalClose = () => {
    dispatch({ type: "SETSELECTEDSUBMISSION", payload: null })
  }

  const sortedRebates = [...rebates].sort(
    (a, b) => new Date(b.stampDate) - new Date(a.stampDate)
  )

  return (
    <>
      <div style={{ marginTop: 36 }}>
        <h2 style={styles.sectionHeader}>{title}</h2>

        {sortedRebates.length === 0 ? (
          <p style={styles.emptyState}>{emptyMessage}</p>
        ) : (
          <ul style={styles.rebateList}>
            {sortedRebates.map((submission) => {
              const { label, dot, bg, text } = getStatusConfig(submission)
              return (
                <li
                  key={submission.trackingId}
                  style={styles.rebateItem}
                  onClick={() => handleRebateClick(submission)}
                  onKeyDown={(e) => e.key === "Enter" && handleRebateClick(submission)}
                  role="button"
                  tabIndex={0}
                  aria-label={`${submission.offer.description}, ${formatOfferValue(submission.offer.offerValue)}, status: ${label}`}
                >
                  <div style={styles.rebateContent}>
                    <div style={styles.rebateTitle}>{submission.offer.description}</div>
                    <div style={styles.rebateValue}>{formatOfferValue(submission.offer.offerValue)}</div>
                    <span style={{ ...styles.badge, backgroundColor: bg, color: text }}>
                      <span style={{ ...styles.badgeDot, backgroundColor: dot }} aria-hidden="true" />
                      {label}
                    </span>
                  </div>
                  <span style={styles.chevron} aria-hidden="true">&#8250;</span>
                </li>
              )
            })}
          </ul>
        )}
      </div>

      {state.selectedSubmission && (
        <RebateDetailModal
          submission={state.selectedSubmission}
          onClose={handleModalClose}
        />
      )}
    </>
  )
}

RebateList.propTypes = {
  rebates: PropTypes.array.isRequired,
  title: PropTypes.string,
  emptyMessage: PropTypes.string,
}
